import { render, staticRenderFns } from "./NavigationMainTitles.vue?vue&type=template&id=f79cb362&scoped=true&"
import script from "./NavigationMainTitles.vue?vue&type=script&lang=js&"
export * from "./NavigationMainTitles.vue?vue&type=script&lang=js&"
import style0 from "./NavigationMainTitles.vue?vue&type=style&index=0&id=f79cb362&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f79cb362",
  null
  
)

export default component.exports